<div class="cover" [ngClass]="{'disabled': !canEditProfile}"></div>
<div
  class="map-container"  
  [ngClass]="{'map-container--disabled': locationForm.disabled}"
  #map>
</div>